export default class FileLoadingManager {
  isLoading = false;

  constructor(store = null) {
    this.store = store
  }

  get isLoading() {
    return this.isLoading
  }

  startLoading() {
    this.isLoading = true
    this.update()
  }

  finishLoading() {
    this.isLoading = false
    this.update()
  }

  update() {
    if (this.store == null) return;
    this.store.commit('fileLoading/updateIsLoading', this.isLoading)
  }
}
